import Vue from 'vue'

export default {

    state: {
        videos: [],
        tracks: [],
        artists: [],
        images: [],
        photos: [],
        concerts: []
    },

    getters: {
        videos: state => state.videos,
        tracks: state => state.tracks,
        artists: state => state.artists,
        images: state => state.images,
        photos: state => state.photos,
        concerts: state => state.concerts
    },

    mutations: {
        videos(state, data) {
            state.videos = data.videos || []
        },

        tracks(state, data) {
            state.tracks = data.tracks || []
        },

        artists(state, data) {
            state.artists = data.artists || []
        },

        images(state, data) {
            state.images = data.images || []
        },

        photos(state, data) {
            state.photos = data.photos || []
        },

        concerts(state, data) {
            state.concerts = data.concerts || []
        }
    },

    actions: {
        async photos(context) {
            return Vue.prototype.$api.get('/photos')
                .then(res => {
                    context.commit('photos', { photos: res.data })
                    return res.data
                })
        },

        async videos(context) {
            return Vue.prototype.$api.get('/videos')
                .then(res => {
                    context.commit('videos', { videos: res.data })
                    return res.data
                })
        },

        async tracks(context) {
            return Vue.prototype.$api.get('/tracks')
                .then(res => {
                    context.commit('tracks', { tracks: res.data })
                    return res.data
                })
        },

        async artists(context) {
            return Vue.prototype.$api.get('/artists')
                .then(res => {
                    context.commit('artists', { artists: res.data })
                    return res.data
                })
        },

        async concerts(context) {
            return Vue.prototype.$api.get('/concerts')
                .then(res => {
                    context.commit('concerts', { concerts: res.data })
                    return res.data
                })
        }
    }
}
